import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';


@Component({
    selector: 'modal-error',
    templateUrl: 'modal-error.html'
})

export class ModalErrorComponent implements OnInit {
    @Input() showModal;
    @Input() data;
    @ViewChild('errorModal') public errorModal:ModalDirective;
    @Output() emitCloseModal = new EventEmitter();
    constructor() { }

    public onHidden():void{
       this.errorModal.hide()
    }

    public closeModal():void{
       this.errorModal.hide()
    }

    public setCommentType(comment: any) {
        if(comment.type == "reload") return 'c-comment';
        else if(comment.type == "cancel") return 'c-comment--alert';
        else if(comment.type == "user") return 'c-comment--user';
        else if(comment.type == "incidence") return 'c-comment--alert';
        else return 'c-comment';
    }

    ngOnChanges(value) {
        (this.showModal) ? this.errorModal.show() : this.errorModal.hide();
    }
    ngOnInit() {}
}


// WEBPACK FOOTER //
// ./src/app/common/modal-error/modal-error.component.ts